import * as React from 'react';
import TextField from '@mui/material/TextField';

const style = {
  '& label': {
    height: '15px',
    fontSize: 13
  },
  '& div': {
    backgroundColor: 'white'
    // '& .Mui-disabled': {
    //     backgroundColor: '#EAEAEA'
    // }
  },
  '& input': {
    height: '1.1rem',
    fontSize: 13
  },
  '& input:disabled': {
    backgroundColor: '#EAEAEA'
  }
};

export default function CustomTextField(props) {
  const { sx, require, ...rest } = props;

  return <TextField size="small" variant="outlined" sx={{ ...style, ...sx }} {...rest} />;
}
